<template>
    <div class="col-sm-4 px-0 currency input-group d-flex justify-content-between align-items-center">
        <span>{{ label }}</span>
        <div class="number-input align-items-center d-flex">
            <img @click="stepDown()" src="@/assets/svg/minus-767676.svg">
            <span :class="{'inputHolder' : percentage}">
                <input @change="inputChanged($event)" :readonly="readonly" v-model="initialValue" type="number" class="number">
            </span>
            <img @click="stepUp()"  src="@/assets/svg/plus-767676.svg">
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      counter: this.amount
    }
  },
  props: {
    label: {
      default: '',
      type: String,
      required: false
    },
    amount: {
      default: 0,
      type: String | Number,
      required: false
    },
    min: {
      default: 0,
      type: String | Number,
      required: false
    },
    max: {
      default: 250,
      type: String | Number,
      required: false
    },
    percentage: {
      default: false,
      type: Boolean,
      required: false
    },
    readonly: {
      default: false,
      type: Boolean,
      required: false
    },
    item: {
      type: Object,
      required: false
    },
    eventCode: {
      default: '',
      type: String,
      required: false
    }
  },
  computed: {
    initialValue () {
      if (parseInt(this.min) > 0) {
        return parseInt(this.min)
      } else {
        return parseInt(this.amount)
      }
    }
  },
  methods: {
    inputChanged (event) {
      this.$emit('inputChanged' + this.eventCode, event.target.value, this.item)
    },
    stepUp () {
      if (this.readonly || parseInt(this.counter) === parseInt(this.max)) {
        return false
      }
      this.counter++
      this.$emit('inputChanged' + this.eventCode, this.counter, this.item)
    },
    stepDown () {
      if (this.readonly || parseInt(this.counter) === parseInt(this.min)) {
        return false
      }
      this.counter--
      this.$emit('inputChanged' + this.eventCode, this.counter, this.item)
    }
  },
  watch: {
    counter (val) {
      this.$emit('update:amount', val)
    }
  }
}
</script>

<style scoped>
    .inputHolder::after {
        content: '%';
    }

    input.number {
      width: 34px !important;
      text-align: center;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    input[type=number] {
      -moz-appearance: textfield;
    }
</style>



// WEBPACK FOOTER //
// src/components/core/NumberInput.vue